/**
 * DID inventory API module.
 * Backend endpoints live in control-plane/backend/app/api/v1/endpoints/dids.py.
 */
import apiClient from "./client";
import type {
  DID,
  DIDAssignPayload,
  DIDAssignment,
  DIDCreatePayload,
  DIDInventoryStats,
  DIDListParams,
  DIDUpdatePayload,
} from "../types/did";

/** DID inventory management endpoints. */
export const didsApi = {
  /** Create a new DID. */
  create: (data: DIDCreatePayload) => apiClient.post<DID>("/api/v1/dids/", data),

  /** List DIDs with filters and pagination. */
  list: (params?: DIDListParams) =>
    apiClient.get<DID[]>("/api/v1/dids/", { params }),

  /** Get inventory statistics (counts per status + monthly revenue). */
  stats: () => apiClient.get<DIDInventoryStats>("/api/v1/dids/stats"),

  /** Assign a DID to a customer account. */
  assign: (didId: string, data: DIDAssignPayload) =>
    apiClient.post<DID>(`/api/v1/dids/${didId}/assign`, data),

  /** Release a DID back to the available pool. */
  unassign: (didId: string) =>
    apiClient.post<DID>(`/api/v1/dids/${didId}/unassign`),

  /** Get the assignment history for a DID. */
  assignments: (didId: string) =>
    apiClient.get<DIDAssignment[]>(`/api/v1/dids/${didId}/assignments`),

  /** Delete a DID (fails while assignments exist). */
  remove: (didId: string) => apiClient.delete<void>(`/api/v1/dids/${didId}`),
};

/** Re-exported for convenience so pages can type filter state. */
export type { DIDUpdatePayload };
